import {createApp} from 'vue';
import OutDirective from '@/directives/out';

const components = import.meta.glob('../components/*.vue');

export function mountVueComponent(elementId, componentName, props = {}) {
    const el = document.getElementById(elementId);

    if (!el) {
        console.warn(`Element with ID "${elementId}" not found.`);
        return Promise.resolve(null);
    }

    const load = components[`../components/${componentName}.vue`];
    if (!load) {
        console.error(`Failed to load component ${componentName}.`);
        return Promise.resolve(null);
    }

    return load().then((module) => {
        const app = createApp(module.default, props);
        app.directive('out', OutDirective);
        el._vueApp = app;
        app.mount(el);
        return app;
    }).catch((err) => {
        console.error(`Failed to load component ${componentName}:`, err);
        return null;
    });
}

export function mountDataComponents(root = document) {
    root.querySelectorAll('[data-vue]').forEach((el) => {
        mountVueComponent(el.id, el.dataset.vue, JSON.parse(el.dataset.props || '{}'));
    });
}
